import styled from 'styled-components';
import _ from 'lodash';
import QueryString from 'query-string';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import { Flex } from '../base/layout-components';
import AppRouter from 'common/AppRouter';
import LinkArrow from 'images/icons/link-arrow.svg';
import BoldedValue from '../BoldedValue';
import { CAN_EDIT_ACCOUNT_TYPES, metricNames } from '@linearb/linjs-common';
// import Pencil from 'images/icons-js/Pencil';
import Icon from 'components/base/Icon';
import { LinkWithoutUnderline } from './ContributorsRosterByTeam';
import RelativeCircle from '../RelativeCircle';
import { getRandomIntInclusive } from 'common/utils/utils';
import { SkeletonRow } from '../Skeleton';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING, SEARCH_DATE_FORMAT } from 'common/constants/constants';
import withPermissions from 'connected-components/HOC/PermissionsHOC';
import { StyledWidgetHeader } from 'components/base/common-styles';
import { LBButton } from '@linearb/buzz';
export const DEFAULT_METRIC_VALUE = 0;

export const PlaceHolderCircle = () => (
  <RelativeCircle
    value={getRandomIntInclusive(0, 5)}
    valuesConfig={[0.5, 1.5, 2.5, 4]}
    color='catskillWhite'
    opacity={1}
  />
);
export const PlaceHolderRow = () => (
  <SkeletonRow width={`${getRandomIntInclusive(2, 15)}rem`} />
);

export const getDataMetricToColumnConfigMap = (
  teamId,
  currentIteration,
  isRetrospect
) => {
  return {
    [metricNames.ACTIVE_BRANCHES]: {
      name: isRetrospect ? 'CARRYOVER' : 'ACTIVE BRANCHES',
      logEvent: () =>
        TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
          page: TRACKING.PAGES.DASHBOARD,
          click_type: TRACKING.CLICK.TEAM_BRANCHES
        }),
      link: {
        pathname: AppRouter.BRANCH.path,
        search: QueryString.stringify({
          metric_name: metricNames.DONE_BRANCHES,
          teams: teamId,
          time_range: [
            moment(currentIteration.start_date).format(SEARCH_DATE_FORMAT),
            moment
              .min(moment(currentIteration.end_date), moment())
              .format(SEARCH_DATE_FORMAT)
          ].join(',')
        })
      },
      tooltipTitle: 'view active branches'
    },
    [metricNames.REVIEWS]: { name: 'REVIEWS' },
    [metricNames.DONE_BRANCHES]: {
      name: 'DONE',
      link: {
        pathname: AppRouter.BRANCH.path,
        search: QueryString.stringify({
          metric_name: metricNames.DONE_BRANCHES,
          teams: teamId,
          time_range: [
            moment(currentIteration.start_date).format(SEARCH_DATE_FORMAT),
            moment
              .min(moment(currentIteration.end_date), moment())
              .format(SEARCH_DATE_FORMAT)
          ].join(',')
        })
      },
      tooltipTitle: 'view done branches'
    },
    [metricNames.ACTIVE_DAYS]: { name: 'ACTIVE DAYS' }
  };
};
export const getNameColumnHeaderComponent = ({
  selectedTeam,
  currentIteration,
  onConfigureTeam
}) => {
  return (
    <Flex items='center' justify='space-between'>
      <Flex items='center'>
        <StyledWidgetHeader style={{ paddingRight: '1rem' }}>
          Team Members
        </StyledWidgetHeader>

        {withPermissions({
          WrappedComponent: (
            <LBButton
              variant='ghost'
              size='icon'
              onClick={() => {
                onConfigureTeam({ team: selectedTeam });
              }}
            >
              <Tooltip title={'Edit Team'}>
                <PencilIcon>
                  <Icon name='Pencil' color='dodgerBlue' />
                </PencilIcon>
              </Tooltip>
            </LBButton>
          ),
          requiredPermissions: CAN_EDIT_ACCOUNT_TYPES
        })}
      </Flex>
      <Tooltip title='More details on people activity'>
        <LinkWithoutUnderline
          to={{
            pathname: AppRouter.INDIVIDUALS.path,
            search: QueryString.stringify({
              teams: _.get(selectedTeam, 'id'),
              time: `${_.get(currentIteration, 'start_date')},${_.get(
                currentIteration,
                'end_date'
              )}`
            })
          }}
        >
          <LBButton size='icon' variant='ghost'>
            <LinkIcon src={LinkArrow} alt='go' />
          </LBButton>
        </LinkWithoutUnderline>
      </Tooltip>
    </Flex>
  );
};
export const getHeaderComponent =
  (value, link, hideValues, logEvent = _.noop, tooltipTitle) =>
  ({ children }) => {
    return (
      <Flex height='4.2rem' items='center' justify='space-between'>
        <Flex>
          {!hideValues && (
            <BoldedValue
              value={{ text: value || DEFAULT_METRIC_VALUE, size: 'x-x-large' }}
            />
          )}
          {children}
        </Flex>
        {link && (
          <Tooltip title={tooltipTitle}>
            <LinkWithoutUnderline onClick={logEvent} to={link}>
              <LBButton size='icon' variant='ghost'>
                <LinkIcon src={LinkArrow} alt='go' />
              </LBButton>
            </LinkWithoutUnderline>
          </Tooltip>
        )}
      </Flex>
    );
  };
const PencilIcon = styled(Flex)`
  width: 1.2rem;
`;
const LinkIcon = styled.img`
  width: 1rem;
  height: 1rem;
`;
